"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExtendedErrorInfoPanel = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _ErrorButtonDebug = require("../ErrorButton/ErrorButtonDebug");
var _CopyToShare = require("./CopyToShare");
var _DevInfoPanel = require("./DevInfoPanel");
var _ErrorInfoSection = require("./ErrorInfoSection");
var _ErrorMessage = require("./ErrorMessage");
var _FetchInfoSection = require("./FetchInfoSection");
var _StackTraceSection = require("./StackTraceSection");
var _jsxRuntime = require("react/jsx-runtime");
function parseErrorFromWindow() {
  const nextData = window.__NEXT_DATA__;
  const error = nextData?.props?.pageProps?.error;
  return error;
}
function extractErrorsFromCause(error) {
  // Return an empty array as a placeholder implementation
  if (error == null || typeof error !== 'object') {
    return [];
  }
  const errorObj = error;
  const errors = [errorObj];
  if (errorObj.cause != null && typeof errorObj.cause === 'object') {
    errors.push(...extractErrorsFromCause(errorObj.cause));
  }
  return errors;
}
const ExtendedErrorInfoPanel = ({
  errorCode,
  operationId,
  operationResourceId,
  developmentInfo
}) => {
  const error = parseErrorFromWindow();
  const statusCode = errorCode !== 0 && errorCode != null ? errorCode : 500;
  const errors = extractErrorsFromCause(error);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Paper, {
    elevation: 3
    // eslint-disable-next-line react/forbid-component-props -- No need to optimize on error page
    ,
    sx: {
      mt: 6,
      p: 4,
      mx: {
        xs: 2,
        md: 0
      },
      borderRadius: 2,
      border: '1px solid #333'
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Grid, {
      container: true,
      direction: "row"
      // eslint-disable-next-line react/forbid-component-props -- fine for error page
      ,
      sx: {
        justifyContent: 'space-between',
        alignItems: 'flex-start'
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Grid, {
        size: "grow"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Grid, {
        size: 3,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Typography, {
          variant: "h6",
          mb: 3,
          children: ["Extended Error Info", /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Tooltip, {
            title: "This extended info is available only in test environments. Share it whole with the development team to help them debug the issue.",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ErrorCircleFilled, {
              fontSize: "inherit"
            })
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ErrorMessage.ErrorMessageSection, {
          statusCode: statusCode,
          owner: developmentInfo?.teamName
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Grid, {
        size: "grow",
        justifyItems: "right",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Stack, {
          spacing: 2,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ErrorButtonDebug.ErrorButtonDebug, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_CopyToShare.CopyToShare, {
            data: {
              errorCode,
              errors,
              operationId,
              operationResourceId,
              developmentInfo
            }
          })]
        })
      })]
    }), errors.map((errorItem, index) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [index !== 0 ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Divider
      // eslint-disable-next-line react/forbid-component-props -- No need to optimize on error page
      , {
        sx: {
          mb: 2,
          borderColor: '#444'
        }
      }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        gutterBottom: true,
        variant: "subtitle1",
        children: index === 0 ? 'Error:' : 'Caused By:'
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ErrorInfoSection.ErrorInfoSection, {
        errorMessage: errorItem.message
      }), errorItem.stack ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_StackTraceSection.StackTraceSection, {
        errorStack: errorItem.stack
      }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_FetchInfoSection.FetchInfoSection, {
        fetchInfo: errorItem.fetchInfo
      })]
    })), developmentInfo !== undefined && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Box, {
      mb: 3,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Divider
      // eslint-disable-next-line react/forbid-component-props -- No need to optimize on error page
      , {
        sx: {
          mb: 2,
          borderColor: '#444'
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_DevInfoPanel.DevInfoPanel, {
        developmentInfo: developmentInfo
      })]
    })]
  });
};
exports.ExtendedErrorInfoPanel = ExtendedErrorInfoPanel;
